<div class="d-flex align-items-center" mat-dialog-title>
    <span>{{ isEditMode ? 'Contactpersoon bewerken' : 'Contactpersoon toevoegen' }}</span>
    <span class="flex-fill"></span>
    <button (click)="cancel()" mat-icon-button tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content>
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Voornaam</mat-label>
                    <input formControlName="first_name" matInput />
                    <mat-error>Dit veld is verplicht</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Achternaam</mat-label>
                    <input formControlName="last_name" matInput />
                    <mat-error>Dit veld is verplicht</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Telefoon</mat-label>
                    <input formControlName="phone_number" matInput type="tel" />
                    <mat-error>Vul een geldig telefoonnummer in</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>E-mailadres</mat-label>
                    <input formControlName="email" matInput type="email" />
                    <mat-error>Vul een geldig e-mailadres in</mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>

<div class="justify-content-between" mat-dialog-actions>
    <button [disabled]="saving" (click)="cancel()" mat-button>Annuleren</button>
    <button [disabled]="saving" (click)="save()" mat-raised-button color="primary">
        @if (!saving) {
            <span>Opslaan</span>
        } @else {
            <span class="d-flex align-items-center">
                <mat-spinner class="me-2" diameter="20"></mat-spinner>
                Opslaan...
            </span>
        }
    </button>
</div>
